<template>
  <div class="err-fixed-page" v-loading="loading">
    <div class="err-msg">
      <div class="page-title">错误信息</div>
      <pageTable
        class="err-list-table"
        :col="errList"
        :data="tableData"
        :showPage="false"
        :noDataHeight="130"
        hoverColor="#f3f6f8"
      ></pageTable>
    </div>
    <err-fixed-form
      v-if="isHasPermission"
      :id="$route.params.id"
      :type="$route.params.type"
      :libForm="libForm"
      :isShowFooter="isShowFooter"
      :btnDisabled="btnDisabled"
      @submit="submit"
      @back="goBack">
    </err-fixed-form>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import errFixedForm from './components/errFixedForm.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import axios from 'axios'
import { msg } from '@/utils/index'
import { getFixedInfo, SingleCorrection, fixedInfoSubmit } from '@/api/goodStand'

export default {
  name: 'errFixed',
  mixins: [pageTableMixin],
  components: {
    pageTable, errFixedForm
  },
  data() {
    return {
      loading: false,
      isShowFooter: false,
      isHasPermission: true,
      libForm: {},
      correction_ids: [],
      btnDisabled: false,
      correctList: {
        jiyaoData: {
          permission: '中国基药数据库',
          info: 'ji-yao',
          getList: 'JiYao'
        },
        guochanData: {
          permission: '国产药品数据库',
          info: 'guochan-yaopin',
          getList: 'GuoChanYaoPin'
        },
        jinkouData: {
          permission: '进口药品数据库',
          info: 'jinkou-yaopin',
          getList: 'JinKouYaoPin'
        },
        yibaoData: {
          permission: '中国医保数据库',
          info: 'yibao-yaopin',
          getList: 'YiBao'
        },
        companyData: {
          permission: '生产企业数据库',
          info: 'sheng-chan-qi-ye',
          getList: 'ShengChanQiYe'
        },
        shangyeData: {
          permission: '中国商业数据库',
          info: 'shang-ye',
          getList: 'ServiceInfoCorp'
        },
        yiliaoData: {
          permission: '中国医疗机构库',
          info: 'yi-liao-ji-gou',
          getList: 'YiLiaoJiGou'
        },
        yaodianData: {
          permission: '中国药店数据库',
          info: 'yao-dian',
          getList: 'ServiceInfoShop'
        },
        yiyuanData: {
          permission: '中国医院数据库',
          info: 'yi-yuan',
          getList: 'ServiceInfoHospital'
        },
        doctorData: {
          permission: '医生数据库',
          info: 'doctor',
          getList: 'YiSheng'
        }
      },
      errList: [
        { field: 'field_title', title: '错误字段', width: 160, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'content', title: '错误描述', width: 290, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'seller_truename', title: '提出人', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'company_name', title: '公司名称', width: 230, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'create_time', title: '提出时间', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return rowData['create_time'].split(' ')[0]
          }
        }
      ],
      tableData: []
    }
  },
  watch: {
    $route: {
      handler() {
        this.hasPagePermission()
      },
      immediate: true
    }
  },
  methods: {
    hasPagePermission() {
      const permissionList = this.$store.state.user.roles.map(item => item.name)
      const curList = this.correctList[this.$route.params.type].permission
      if (!permissionList.includes(curList)) {
        this.isHasPermission = false
        this.$router.push({
          path: '/404'
        })
      }
    },
    goBack() {
      this.$emit('back')
    },
    initPage() {
      const pageObj = {
        title: '纠错处理',
        type: 'card-footer2',
        url: this.$route.params.type,
        params: { type: '2' }
      }
      this.$store.dispatch('setPage', pageObj)
    },
    getData() {
      const id = this.$route.params.id
      const correctionParams = {
        type: this.correctList[this.$route.params.type].getList,
        row_id: id
      }
      const infoParams = {
        id: id
      }
      this.loading = true
      axios.all([
        SingleCorrection(correctionParams),
        getFixedInfo(infoParams, this.correctList[this.$route.params.type].info)
      ]).then(axios.spread((res1, res2) => {
        this.loading = false
        this.isShowFooter = true
        this.tableData = res1.result.list
        this.libForm = res2.result.info
      }))
    },
    submit(params) {
      this.btnDisabled = true
      this.correction_ids = this.tableData.map(item => item.id)
      params = this.addQuery(params, 'correction_ids', this.correction_ids)
      fixedInfoSubmit(params, this.correctList[this.$route.params.type].info).then(res => {
        if (res.code === 0) {
          this.$emit('back')
        } else {
          msg.call(this, res.msg)
        }
        this.btnDisabled = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .edit-block-side {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    .ivu-input-wrapper,
    .ivu-select,
    .ivu-date-picker {
      width: 220px;
    }
    .ivu-input {
      line-height: 18px !important;
    }
  }
  .err-msg {
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(236,240,247,1);
    .page-title {
      margin-top: 0;
      margin-bottom: 30px;
      font-size: 14px;
      line-height: 14px;
    }
  }
  .basic-msg {
    padding-top: 30px;
  }
  .ivu-date-picker {
    width: 100%;
  }
</style>
<style lang="scss">
.err-list-table {
  .v-table-views {
    max-height: 212px;
  }
  .v-table-body {
    max-height: 160px;
  }
}
</style>

